import React from 'react';
import { getMainTenantStatus, getStatusSupportingText } from '../tenantHelpers';

const normalizeClass = (value) =>
  String(value || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-');

const TenantStatus = ({ tenant }) => {
  const status = getMainTenantStatus(tenant);
  const supporting = getStatusSupportingText(tenant);

  return (
    <div className="stm-status">
      <span className={`stm-status__badge stm-status__badge--${normalizeClass(status)}`}>
        {status}
      </span>
      {supporting && <span className="stm-status__support">{supporting}</span>}
    </div>
  );
};

export default TenantStatus;
